var CollectionFilter = (function ($) {

    var _public = {},
        _private = {},
        i,
        maxlength = 1000,
        productIndex = 1;

    _private.parent_collection_handle = '';
    _private.child_collection_handle = '';
    _private.$products_container = $('#right-main-content .grid-products');
    _private.$loading = $('#right-main-content');

    _public.parent_collection = [];
    _public.child_collection = [];
    _public.active_tags = [];
    _public.matching_products = [];
    _public.initial_history_length = window.history.length;


    _public.init = function () {
        setParentCollectionHandle();
        getParentCollectionJSON();
        setCheckoxesFromURL();
        buildTagsListFromCheckboxes();
        listen();
        filterToggle();
        productSort();

    };

    return _public;

    function productSort(){
      $('.col-sort').on('click', function(){
        $(this).parent().next().toggleClass('is-active');
        return false;
      });
      $('.col-filter').on('click', function(){
        $('#left-sidebar').addClass('is-active');
        return false;
      });
      $('.js-filter-close').on('click', function(){
        $('#left-sidebar').removeClass('is-active');
      });
    }

    function filterToggle(){
      $('.flex-subhead').on('click', function() {
        $(this).parent().find('ul').slideToggle();
        $(this).toggleClass('icon-flip');
      });
    }

    function listen() {

        // Detect filter changes
        $(document).on('change', '#left-sidebar input[type="checkbox"]', function (event) {
            productIndex = 1;
            buildTagsListFromCheckboxes();
            updateURLFromActiveTags();
            updateControlBar();
            filterProducts();
            sortProducts();
            drawProducts();
            updateControlBar();
        });

        // Detect clicks on filter badges (which is a removal request)
        $(document).on('click', '.filter-badge', function (event) {
            productIndex = 1;
            var this_tag = $(this).data('filter-tag');
            var $corresponding_checkbox = $('#left-sidebar input[value="' + this_tag + '"]');
            $corresponding_checkbox.prop('checked', false);
            buildTagsListFromCheckboxes();
            updateURLFromActiveTags();
            filterProducts();
            sortProducts();
            drawProducts();
            updateControlBar();
        });

        // Detect sort order changes
        $(document).on('change', '#sort-collection', function (event) {
            productIndex = 1;
            sortProducts();
            drawProducts();
        });

    }

    // Eventually, this needs to be able to automatically detect topmost collection even when we start on a subcollection page.
    // Any of: Telescopes, Accessories, Eyepieces...
    function setParentCollectionHandle() {
        _private.parent_collection_handle = $('#filter-list', '#template').data('parent-collection-handle');
        _private.child_collection_handle = $('#filter-list', '#template').data('child-collection-handle');
    }

    function getParentCollectionJSON() {
        var params = {
            type: 'GET',
            url: '/collections/' + _private.parent_collection_handle + '?view=json',
            dataType: 'html',
            success: function (data) {
                var JSON_data = JSON.parse(data);
                _public.parent_collection = JSON_data.collection;
                _public.matching_products = JSON_data.collection;

                attachAdditionalProductData();
                // insert whatever code is necessary here to redraw complete listing after initial page load (which could be incomplete)
                buildTagsListFromCheckboxes();
                updateURLFromActiveTags();
                filterProducts();
                sortProducts();
                drawProducts();
                updateControlBar();
            },
            error: function (XMLHttpRequest, textStatus) {}
        };
        $.ajax(params);
        return false;
    }

    function buildTagsListFromCheckboxes() {
        // clear any previously set filters
        _public.active_tags = [];

        var $active_filters = $('#left-sidebar input[type="checkbox"]:checked'),
            $filter;
        for (i = 0; i < $active_filters.length; i++) {
            $filter = $active_filters.eq(i);
            _public.active_tags.push($filter.val());
        }

        // update URL while we're at it
        if (history.pushState) {
            updateURLFromActiveTags();
        }
        return false;
    }

    function filterProducts() {

        _public.categories_arrays = buildCategoriesArrayForFiltering();

        var matching_products = _public.parent_collection.slice();

        if (_public.active_tags.length === 0) {
            // when `_public.active_tags` is empty, there are no active filters, so we don't touch the matching_products array
        } else {
            // loop through all products. we're going in reverse so index doesn't get out of sync when we remove inappropriate products
            for (var i = matching_products.length - 1; i >= 0; i--) {
                var is_match = doesProductMatch(matching_products[i]);

                // remove any products that don't contain matching tags
                if (is_match === false) {
                    matching_products.splice(i, 1);
                }
            }
        }
        _public.matching_products = matching_products;
        return false;
    }

    function doesProductMatch(product) {
        var matches_all_conditions = true;

        // iterate through categories
        for (var key in _public.categories_arrays) {
            if (_public.categories_arrays.hasOwnProperty(key)) {
                var category_tags = _public.categories_arrays[key];

                // iterate through category tags. product.tags must contain all of these >:(
                for (var i = 0; i < category_tags.length; i++) {
                    var category_tag = category_tags[i];
                    if (product.tags.indexOf(category_tag) < 0) {
                        matches_all_conditions = false;
                    }
                }
            }
        }
        return matches_all_conditions;
    }

    // run this function in console against CollectionFilter.active_tags and see what is returned
    function buildCategoriesArrayForFiltering() {
        var active_category_titles = [];
        var categories_arrays = {};

        for (var i = 0; i < _public.active_tags.length; i++) {
            var this_tag = _public.active_tags[i];
            var this_tags_parent_category_title = $('#left-sidebar input[value="' + this_tag + '"]').closest('ul').siblings('h5').children('a').html();

            if (active_category_titles.indexOf(this_tags_parent_category_title) === -1) {
                active_category_titles.push(this_tags_parent_category_title);
                categories_arrays[this_tags_parent_category_title] = [this_tag];
            } else {
                categories_arrays[this_tags_parent_category_title].push(this_tag);
            }
        }
        return categories_arrays;
    }

    // Given the situation, pulling grid-item's layout HTML from a liquid snippet isn't practical. Gotta "hard-code" it.
    function drawProducts() {
        // clear previously drawn products
        if (productIndex == 1) {
            _private.$products_container.html('');
        }
        var products_to_show = _public.matching_products.length < maxlength * productIndex ? _public.matching_products.length : maxlength * productIndex;
        for (i = (productIndex - 1) * maxlength; i < products_to_show; i++) {
            var product = _public.matching_products[i],
                average_rating = product.average_rating,
                review_count = product.review_count,
                review_text = review_count > 1 ? review_count + ' Reviews' : review_count + ' Review';

            if(review_count == 0) {
              review_text = review_count + 'No Reviews Yet';
            }

            var html = '' +
                '<li class="grid-single-product with-cart-form">' +
                '  <a class="product-wrapper" href="' + '/collections/' + _private.parent_collection_handle + product.url + '">' +
                '    <figure>' +
                '      <img src="' + product.img_url + '" alt="' + product.title + '">' +
                '    </figure>' +
                '    <article>' +
                '      <p class="product-title">' + product.title + '</p>';
              html += '<div class="review_summary">' +
                      '<div class="star_rating">' +
                      Reviews.getHTML(average_rating) +
                      '</div><div class="review_count">'+
                      review_text +
                      '</div></div>';
            if (product.compare_at_price_max > 0 && product.compare_at_price_max > product.price) {
                html += '' +
                    '      <div class="price-block">' +
                    '        <span class="product-price our-price sale-price">' +
                    '          <em>Sale Price:</em> ' +
                    '          <strong>' + formatMoney(product.price) + '</strong>' +
                    '        </span>' +
                    '        <span class="product-price list-price">' +
                    '          <em>List Price:</em>' +
                    '          <s>' + formatMoney(product.compare_at_price_max) + '</s>' +
                    '        </span>' +
                    '      </div>';
            } else if (product.compare_at_price_max > 0 && product.compare_at_price_max == product.price) {
                html += '' +
                    '      <div class="price-block">' +
                    '        <span class="product-price our-price sale-price">' +
                    '          <em>Our Price:</em> ' +
                    '          <strong>' + formatMoney(product.price) + '</strong>' +
                    '        </span>' +
                    '        <span class="product-price list-price">' +
                    '          <span>&nbsp;</span>' +
                    '        </span>' +
                    '      </div>';
            } else {
                html += '' +
                    '      <div class="price-block">' +
                    '        <span class="product-price our-price sale-price">' +
                    '          <em>Our Price:</em> ' +
                    '          <strong>' + formatMoney(product.price) + '</strong>' +
                    '        </span>' +
                    '        <span class="product-price list-price">' +
                    '          <span>&nbsp;</span>' +
                    '        </span>' +
                    '      </div><!-- .price-block -->';
            }
            html += '' +
                '    </article>' +
                '  </a>' +
                '  <form class="product" action="/cart/add" method="post" enctype="multipart/form-data">' +
                '    <div class="inputs">' +
                '      <div class="qty hide-2">' +
                '        <input type="number" name="quantity" value="1">' +
                '      </div>';
            if (product.variants_count === 1 && product.inventory_quantity > 0) {
                html += '' +
                    '<input type="hidden" name="id" value="' + product.variant_id + '">' +
                    '<input class="add btn primary-button add-to-cart" type="submit" value="Add to Cart" data-handle="' + product.handle + '">';
            } else if (product.variants_count > 1) {
                html += '' +
                    '<a class="add btn primary-button flex-btn" href="' + product.url + '">Select Options</a>';
            } else {
                html += '' +
                    '<div class="add btn primary-button disabled">Out Of Stock</div>';
            }
            html += '' +
                '    </div>' +
                '  </form>' +
                '</li>';
            _private.$products_container.append(html);
        }

			_private.$loading.removeClass('loading');
    	return false;
    }


    function setCheckoxesFromURL() {

        // if tags were passed in via the URL, check off items in DOM
        if (queryStringToJSON().tags) {
            var tags = queryStringToJSON().tags.split(',');

            // for every tag found, set its input to `:checked`
            for (var i = 0; i < tags.length; i++) {
                var tag = decodeURI(tags[i]);
                var $tag = $('#left-sidebar input[value="' + tag + '"]', '#template');
                $tag.attr('checked', 'checked');
            }
        }
        return false;
    }

    function updateURLFromActiveTags() {
        var called = false;
        var updated_url = '/collections/' + _private.parent_collection_handle;
        var ga = ga || (function () {});
        if (_public.active_tags.length !== 0) {
            updated_url += '?tags=';

            for (var i = 0; i < _public.active_tags.length; i++) {
                updated_url += _public.active_tags[i];
                // unless it's the last tag, add a `,`
                if (i !== _public.active_tags.length - 1) {
                    updated_url += ',';
                }
            }

            ga('send', 'pageview', { //send analytics data before redirect
                'hitCallback': function () {
                    called = true;
                    history.replaceState(null, null, updated_url);
                }
            });

            window.setTimeout(function () { //if google analytics is not loading, wait 1s and then redirect
                if (!called) {
                    history.replaceState(null, null, updated_url);
                }
            }, 1000);

        }
        return false;
    }


    function sortProducts() {
        _private.$loading.addClass('loading');
        var sorted_collection = _public.matching_products.slice();
        var $sort_selection = $('#sort-collection', '#template');
        var sort_selection = $sort_selection.val();
        var sort_key = sort_selection.split('-')[0];
        var sort_order = sort_selection.split('-')[1];
        var is_reversed = (sort_order === 'ascending') ? false : true;

        sorted_collection.sort(getComparator(sort_key, is_reversed));
        _public.matching_products = sorted_collection;
        return false;
    }

    function attachAdditionalProductData() {

        var modified_collection = _public.parent_collection.slice();

        for (var i = 0; i < modified_collection.length; i++) {
            // Data Addition: to support `default` sort option, add `original_index` property
            modified_collection[i].original_index = i;

            // Data Addition: Based on product.average_rating, add correct tag. Possible tags are "5 Stars - Highest Rated", "4 - 5 Stars", "3 - 4 Stars", "2 -3 Stars"
            var rating_tag = '';
            var average_rating = Math.floor(parseFloat(modified_collection[i].average_rating));

            if (average_rating == 5) {
                rating_tag = "5 Stars - Highest Rated";
            } else if (average_rating == 4) {
                rating_tag = "4 - 5 Stars";
            } else if (average_rating == 3) {
                rating_tag = "3 - 4 Stars";
            } else if (average_rating == 2) {
                rating_tag = "2 - 3 Stars";
            } else {
                rating_tag = "";
            }

            if (rating_tag) { // unless rating was too low OR nothing was passed, add a tag for it
                modified_collection[i].tags.push(rating_tag);
            }
            // Data addition: Add tags for price
        } // for

        /**
         * Loop through all products and remove any that are discontined.
         * In Shopify, a discontinued product has a non-blank value in the metafield: product.metafields.discontinued.alternatives
         * In JSON, the metafield value is represented by the product object property product['discontinued']
         */
        for (i = modified_collection.length - 1; i >= 0; i--) {
            var product = modified_collection[i];
            if (product.discontinued.length !== 0) {
                modified_collection.splice(i, 1);
            }
        }

        // Here we are modifiying the `original_index` attribute to support display order overrides that favor child collections.
        // The lower the value, the higher up in results each item will appear.
        if (typeof (ChildCollection) != 'undefined') {
            // now copy original index of any matching products
            for (i = 0; i < ChildCollection.length; i++) {
                // `i` here reflects index position of element within child collection.
                var relative_index = ((ChildCollection.length + 100 - i) * 100) * (-1);
                var child_id = ChildCollection[i].id;

                for (var j = 0; j < modified_collection.length; j++) {
                    if (modified_collection[j].id === child_id) {
                        modified_collection[j].original_index = relative_index;
                    }
                }
            }
        }

        // If there is a child collection handle (user is coming from a child collection link), override the
        // parent collection's default sort order with the child's. Also, to avoid dealing with async/promises
        // I'm just creating the `ChildCollection` object inside of `collection.liquid`
        // So, below, any product in our overall list that IS NOT present in the child collection gets the highest
        // index (length of ChildCollection + 1). Otherwise, index is copied from child collection.

        _public.parent_collection = modified_collection;
        _public.matching_products = modified_collection;
        return false;

    }

    function updateControlBar() {
        var $control_bar = $('#right-main-content .filter-controls', '#template');

        // 1. update matches count display
        $control_bar.find('.matches-count span').html(_public.matching_products.length);
        // 2. update active filter badges
        var $badges_container = $('.filter-controls .active-filter-badges', '#template');
        $badges_container.html(''); // clear prev
        for (var i = 0; i < _public.active_tags.length; i++) {
            var badge_html = '' +
                '<a class="filter-badge remove-filter" data-filter-tag="' + _public.active_tags[i] + '">' +
                '  <span class="fa">&#xf055;</span>' + _public.active_tags[i] +
                '</a>';
            $badges_container.append(badge_html);
        }
        return false;
    }

    //-------------------
    // Utility Functions
    //-------------------

    function formatMoney(cents) {
        var output = '';

        cents = cents.toString();
        if (cents.length === 1) {
            cents = '0' + cents;
        }
        var pattern = /^(.*)([0-9]{2})$/;

        var _dollars = cents.match(pattern)[1];
        var _cents = cents.match(pattern)[2];
        _dollars = _dollars.replace(/\B(?=(\d{3})+\b)/g, ",");

        output = '$' + _dollars + '.' + _cents;
        return output;
    }

    function queryStringToJSON(str) {
        return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
            return n = n.split("="), this[n[0]] = n[1], this;
        }.bind({}))[0];
    }

    function getComparator(property, is_reversed) {
        var sort_order;
        if (is_reversed === undefined || is_reversed === false) {
            sort_order = 1;
        } else if (is_reversed === true) {
            sort_order = -1;
        }
        return function (a, b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sort_order;
        };
    }



}(jQuery));
